import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { authApiSlice } from '../../services';

export interface AuthState {
  accessToken: null | string;
  refreshToken: null | string;
  userName: string;
}

// Initialize accessToken from local storage
const accessToken = localStorage.getItem('accessToken') || null;
const refreshToken = localStorage.getItem('refreshToken') || null;
const userName = localStorage.getItem('userName') || '';

const initialState: AuthState = {
  accessToken,
  refreshToken,
  userName,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setCredentials: (state, { payload }: PayloadAction<AuthState>) => {
      state.accessToken = payload.accessToken;
      state.refreshToken = payload.refreshToken;
      state.userName = payload.userName;
    },
    logout: state => {
      state.accessToken = null;
      state.refreshToken = null;
      state.userName = '';
    },
  },
  extraReducers: builder => {
    // Login is the ONLY endpoint that establishes a session. verifyAccount
    // deliberately has no matcher here: it belongs to the forget-password flow
    // and now returns a single-use reset token instead of access/refresh
    // tokens, so writing its payload into auth state would both clobber a live
    // session with `undefined` and re-create the unauthenticated-takeover path
    // that sprint 2 closed on the backend.
    builder.addMatcher(
      authApiSlice.endpoints.login.matchFulfilled,
      (state, { payload }) => {
        state.accessToken = payload.data.accessToken;
        state.refreshToken = payload.data.refreshToken;
        state.userName = payload.data.userName;
      }
    );
  },
});

export const { logout, setCredentials } = authSlice.actions;
export const authReducer = authSlice.reducer;
